export default "__VITE_ASSET__CVU4OTvQ__"